export const GastroTheme = {
  name: 'Gastro Theme',
  themeId: 'gastro'
};